import queryString from 'query-string';

export const getParamByName = (key) => {
    let uri = window.location.search;
    if (window.location.hash) {
        uri = window.location.href.split('?')[1];
    }

    const parsed = queryString.parse(uri);
    return parsed[key];
};

export function getRuntimeConfig() {
    const runtimeEnv = window._env_ || {}; // eslint-disable-line no-underscore-dangle
    const queryConfig = {
        backUrl: getParamByName('backUrl'),
        productId: getParamByName('productId')
    };

    Object.assign(runtimeEnv, queryConfig);
    window._env_ = runtimeEnv; // eslint-disable-line no-underscore-dangle

    return runtimeEnv;
}

export function getConfigSettings() {
    return Object.assign({}, getRuntimeConfig());
}

export function getConfigValue(key) {
    return getConfigSettings()[key];
}

export const NUMBER_OF_LOADING_ITEMS = 36;
